export const LOCALIZATION_NAMESPACE = 'localization';
